import * as constants from './Constants'

// Global state tracking for Plausible
export const PlausibleState = {
    shadesTriedOn: [],
    shadeTimers: {},
    currentShade: 0,

    priorTimeInVTO: 0,
    inVTO: false,
    // Timestamp on VTO entry, seconds in the epoch, generated via Date.now() / 1000.
    timestampEnteredVTO: 0,
    // Timestamp of last shade switch, also in seconds.
    timestampLastShadeSwitch: 0,

    recordShadeTriedOn(shade) {

        if (this.currentShade) {
          // record time on previous shade
          this.shadeTimers[this.currentShade] += (Date.now()/1000 - this.timestampLastShadeSwitch)
        }
        
        if (!this.shadesTriedOn.includes(shade)) {
            this.shadesTriedOn.push(shade)
        }

        if (!this.shadeTimers[shade]) {
          this.shadeTimers[shade] = 0
        }

        this.currentShade = shade
        this.timestampLastShadeSwitch = Date.now()/1000
    },

    recordShadeCleared() {
      this.currentShade = 0
      this.timestampLastShadeSwitch = Date.now()/1000
      this.shadeTimers[this.currentShade] += (Date.now()/1000 - this.timestampLastShadeSwitch)
    },

    getNumberProductTries() {
        return(this.shadesTriedOn.length)
    },    

    getTimeOnShade(shade) {

      var timeOnShade
      if (this.inVTO && this.currentShade == shade) {
        timeOnShade = this.shadeTimers[shade] + (Date.now()/1000 - this.timestampLastShadeSwitch)
      }
      else if (this.shadeTimers[shade]) {
        timeOnShade = this.shadeTimers[shade]
      }
      else {
        timeOnShade = 0
      }

      return (Math.floor(timeOnShade))
    },

    getTimeInVTO() {

        var timeInVTO = this.priorTimeInVTO;
    
        if (this.inVTO) {
            timeInVTO += Date.now() / 1000 - this.timestampEnteredVTO;
        }
    
        return (Math.floor(timeInVTO))      
    },

    handlePageUpdate(index) {
        // Update Plausible state tracking based on page.
        if (index === constants.REACT_PAGE_VTO) {
        
            this.inVTO = true;
            this.timestampEnteredVTO = Date.now() / 1000;
            this.timestampLastShadeSwitch = Date.now() / 1000;
        }
        else {
    
            if (this.inVTO) {
                // just left VTO, so update timestamp tracking.        
                const timeDelta = Date.now() / 1000 - this.timestampEnteredVTO;
                this.priorTimeInVTO += timeDelta;

                if (this.currentShade) {
                  this.shadeTimers[this.currentShade] += (Date.now()/1000 - this.timestampLastShadeSwitch)
                }
                
                this.inVTO = false;
            }
        }
    }
}